module.exports = __webpack_public_path__ + "static/media/img6.43cc2f5c.svg";